
import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";



import space01 from "../assets/content/industries/Space/1-PARK ITPDS-2020/1.jpg"
import space02 from "../assets/content/industries/Space/2-PARK PGMCLK-20/3.jpg"
import space03 from "../assets/content/industries/Space/3-PARK CDTG-18/a63d4961-4170-4032-b589-1163196454b4-product.jpg"
import space04 from "../assets/content/industries/Space/4-PARK ITD-1020/95a618e6-5454-4d70-a2ce-77f135edd874-product.jpg"
import space05 from "../assets/content/industries/Space/5-PARK RTDG-20/1.jpg"
import space06 from "../assets/content/industries/Space/6-PARK TCR-03/e60e03d7-99c7-456f-962f-64e0a0d3de47-product.jpg"

import sea01 from "../assets/content/industries/Sea/1-PARK ENCODER 32S/1.jpg"
import sea02 from "../assets/content/industries/Sea/2-PARK PCAMi-1000/1.jpg"
import sea03 from "../assets/content/industries/Sea/3- PARK-BHLN23/1.jpg"
import sea04 from "../assets/content/industries/Sea/4-PARK-BHLN24/1.jpg"
import sea05 from "../assets/content/industries/Sea/5- PARK-BPBS39/1.jpg"
import sea06 from "../assets/content/industries/Sea/6-PARK-BPBL-14/2.jpg"
import sea07 from "../assets/content/industries/Sea/7- PARK-BUMT31/1.jpg"
import sea08 from "../assets/content/industries/Sea/8-PARK-BUMT32/2.jpg"
import sea09 from "../assets/content/industries/Sea/9- PARK-ST227/1.jpg"
import sea10 from "../assets/content/industries/Sea/10-PARK-ITS100/1.jpg"
import sea11 from "../assets/content/industries/Sea/11-img PARK-SSDVRS/1.jpg"
import sea12 from "../assets/content/industries/Sea/12-PARK GCE Control & Guidance Electronics System/1.jpg"


import land01 from "../assets/content/industries/land/1-PARK ITPDS-2020 & PARK ITPS-X020/1.jpg"
import land02 from "../assets/content/industries/land/2-PARK PGMCLK-20/1.jpg"
import land03 from "../assets/content/industries/land/3-PARK CDTG-18/1.jpg"
import land04 from "../assets/content/industries/land/4- PARK HTB(HUD Test Bench) 2008 _ PARK-MHTB-2009-HDC-2/1.jpg"
import land05 from "../assets/content/industries/land/5- PARK ITD-1020/1.jpg"
import land06 from "../assets/content/industries/land/6- PARK RTDG-20/1.jpg"
import land07 from "../assets/content/industries/land/7- PARK TCR-03/1.jpg"
import land08 from "../assets/content/industries/land/8- PARK X-DAAS-iPro/1.jpg"

import air01 from "../assets/content/industries/air/1-PARK ENCODER 32S/1.jpg"
import air02 from "../assets/content/industries/air/2-PARK PCAMi-1000/1.jpg"
import air03 from "../assets/content/industries/air/3- PARK-BHLN23/1.jpg"
import air04 from "../assets/content/industries/air/4-PARK-BHLN24/1.jpg"
import air05 from "../assets/content/industries/air/5- PARK-BPBS39/1.jpg"
import air06 from "../assets/content/industries/air/6-PARK-BPBL-14/2.jpg"
import air07 from "../assets/content/industries/air/7- PARK-BUMT31/1.jpg"
import air08 from "../assets/content/industries/air/8-PARK-BUMT32/2.jpg"
import air09 from "../assets/content/industries/air/9- PARK-ST227/1.jpg"
import air10 from "../assets/content/industries/air/10-PARK-EIU/1.jpg"
import air11 from "../assets/content/industries/air/11- PARK-ITS100/1.jpg"
import air12 from "../assets/content/industries/air/12- PARK-SSDVRS/1.jpg"
import air13 from "../assets/content/industries/air/13-Aero Engine Control Unit FADEC-2100_2101/2.jpg"
import air14 from "../assets/content/industries/air/14-PARK GCE Control & Guidance Electronics System/1.jpg"
import air15 from "../assets/content/industries/air/15-PARK GCU-01/1.jpg"
import air16 from "../assets/content/industries/air/16- PARK X-DAAS-iPro/1.jpg"

gsap.registerPlugin(
  ScrollTrigger,
  ScrollToPlugin
);

gsap.registerPlugin(ScrollTrigger);

const sections = [
  // ================= SPACE =================
  {
    id: "space",
    title: "SPACE",
    products: [
      {
        img: space01,
        name: "PARK ITPDS-2020 & PARK ITPS-X020",
        description:
          "Integrated Telemetry Data Processors",
      },
      {
        img: space02,
        name: "PARK PGMCLK-20",
        description:
          "Portable, Compact, and Rugged Count Down Timing System.",
      },
      {
        img: space03,
        name: "PARK CDTG-18",
        description:
          "Electronic countdown timing system with alerts and triggers.",
      },
      {
        img: space04,
        name: "PARK ITD-1020",
        description:
          "Integrated Telemetry IF Demodulator for telemetry systems.",
      },
      {
        img: space05,
        name: "PARK RTDG-20",
        description:
          "Integrated Remote Time Display and Countdown Generator.",
      },
      {
        img: space06,
        name: "PARK TCR-03",
        description:
          "Time Code Reader and Card System.",
      },
    ],
  },

  // ================= SEA =================
  {
    id: "sea",
    title: "SEA",
    products: [
      {
        img: sea01,
        name: "PARK ENCODER 32S",
        description:
          "Compact PCM encoder with 32 analog channels.",
      },
      {
        img: sea02,
        name: "PARK PCAMi-1000",
        description:
          "Compact Avionics Module for Instrumentation.",
      },
      {
        img: sea03,
        name: "PARK-BHLN23",
        description:
          "Ruggedized & Reliable Power Dividers.",
      },
      {
        img: sea04,
        name: "PARK-BHLN24",
        description:
          "Ruggedized & Reliable Power Dividers.",
      },
      {
        img: sea05,
        name: "PARK-BPBS39",
        description:
          "L Band & S Band Telemetry Power Amplifiers.",
      },
      {
        img: sea06,
        name: "PARK-BPBL-14",
        description:
          "Telemetry Power Amplifier System.",
      },
      {
        img: sea07,
        name: "PARK-BUMT31",
        description:
          "Telemetry Data Transmitters.",
      },
      {
        img: sea08,
        name: "PARK-BUMT32",
        description:
          "Telemetry Data Transmitters.",
      },
      {
        img: sea09,
        name: "PARK-ST227",
        description:
          "Telemetry Data Transmitters.",
      },
      {
        img: sea10,
        name: "PARK-ITS100",
        description:
          "Integrated Telemetry Data Acquisition System.",
      },
      {
        img: sea11,
        name: "PARK-SSDVRS",
        description:
          "Solid State Digital Video Recording Systems.",
      },
      {
        img: sea12,
        name: "PARK GCE Control & Guidance Electronics System",
        description:
          "Laser-guided bomb control & guidance electronics.",
      },
    ],
  },

  // ================= LAND =================
  {
    id: "land",
    title: "LAND",
    products: [
      {
        img: land01,
        name: "PARK ITPDS-2020 & PARK ITPS-X020",
        description:
          "Integrated Telemetry Data Processors.",
      },
      {
        img: land02,
        name: "PARK PGMCLK-20",
        description:
          "Portable rugged countdown timing system for launch applications.",
      },
      {
        img: land03,
        name: "PARK CDTG-18",
        description:
          "Electronic countdown timing and alert system.",
      },
      {
        img: land04,
        name:"PARK HTB(HUD Test Bench) 2008 / PARK-MHTB-2009-HDC-2",
        description:
          "Specialized HUD Test Bench for military and defence systems.",
      },
      {
        img: land05,
        name: "PARK ITD-1020",
        description:
          "Integrated Telemetry IF Demodulator.",
      },
      {
        img: land06,
        name: "PARK RTDG-20",
        description:
          "Remote Time Display and Countdown Generator.",
      },
      {
        img: land07,
        name: "PARK TCR-03",
        description:
          "Time Code Reader and Card System for synchronization.",
      },
      {
        img: land08,
        name: "PARK X-DAAS-iPro",
        description:
          "Advanced analytics platform for telemetry systems.",
      },
    ],
  },

  // ================= AIR =================
  {
    id: "air",
    title: "AIR",
    products: [
      {
        img: air01,
        name: "PARK ENCODER 32S",
        description:
          "Compact PCM encoder with 32 analog channels.",
      },
      {
        img: air02,
        name: "PARK PCAMi-1000",
        description:
          "Compact Avionics Module for Instrumentation.",
      },
      {
        img: air03,
        name: "PARK-BHLN23",
        description:
          "Ruggedized & Reliable Power Dividers.",
      },
      {
        img: air04,
        name: "PARK-BHLN24",
        description:
          "Ruggedized & Reliable Power Dividers.",
      },
      {
        img: air05,
        name: "PARK-BPBS39",
        description:
          "L Band & S Band Telemetry Power Amplifiers.",
      },
      {
        img: air06,
        name: "PARK-BPBL-14",
        description:
          "Telemetry Power Amplifiers.",
      },
      {
        img: air07,
        name: "PARK-BUMT31",
        description:
          "Telemetry Data Transmitters.",
      },
      {
        img: air08,
        name: "PARK-BUMT32",
        description:
          "Telemetry Data Transmitters.",
      },
      {
        img: air09,
        name: "PARK-ST227",
        description:
          "Telemetry Data Transmitters.",
      },
      {
        img: air10,
        name: "PARK-EIU",
        description:
          "Engine Instrumentation Unit.",
      },
      {
        img: air11,
        name: "PARK-ITS100",
        description:
          "Integrated Telemetry Data Acquisition System.",
      },
      {
        img: air12,
        name: "PARK-SSDVRS",
        description:
          "Solid State Digital Video Recording Systems.",
      },
      {
        img: air13,
        name: "PARK FADEC-2100 & FADEC-2101",
        description:
          "Full Authority Digital Engine Control system.",
      },
      {
        img: air14,
        name: "PARK GCE Control & Guidance Electronics System",
        description:
          "Laser-guided bomb control & guidance electronics.",
      },
      {
        img: air15,
        name: "PARK GCU-01",
        description:
          "Generator Control Unit for airborne electrical systems.",
      },
      {
        img: air16,
        name: "PARK X-DAAS-iPro",
        description:
          "Advanced analytics telemetry platform.",
      },
    ],
  },
];


const WhatWeDo = () => {
  const [activeTab, setActiveTab] = useState("space");

  const sectionRefs = useRef({});
  const tabRefs = useRef({});

  // TAB CLICK
  const handleTabClick = (id) => {
    setActiveTab(id);

    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: sectionRefs.current[id],
        offsetY: 100,
      },
      // ease: "power2.out",
    });
  };

  useEffect(() => {
    const sectionsList = Object.values(sectionRefs.current);

    sectionsList.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top center",
        end: "bottom center",

        onEnter: () => {
          setActiveTab(section.id);
        },

        onEnterBack: () => {
          setActiveTab(section.id);
        },
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);


  useEffect(() => {
  const header = document.querySelector("header");

  if (!header) return;

  if (activeTab) {
    header.classList.add("hide-header");
  } else {
    header.classList.remove("hide-header");
  }

  return () => {
    header.classList.remove("hide-header");
  };
}, [activeTab]);

  // ACTIVE TAB ANIMATION
  useEffect(() => {
    Object.keys(tabRefs.current).forEach((id) => {
      gsap.to(tabRefs.current[id], {
        duration: 0.3,
        backgroundColor:
          activeTab === id ? "#000" : "transparent",
        color: activeTab === id ? "#fff" : "#000",
        // scale: activeTab === id ? 1.05 : 1,
      });
    });
  }, [activeTab]);

useEffect(() => {
  sections.forEach((section) => {
    const el = sectionRefs.current[section.id];

    if (!el) return;

    if (activeTab === section.id) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out",
        pointerEvents: "auto",
      });
    } else {
      gsap.to(el, {
        opacity: 0.3,
        y: 40,
        duration: 0.4,
        ease: "power2.out",
        pointerEvents: "none",
      });
    }
  });
}, [activeTab]);

useEffect(() => {
  sections.forEach((section) => {
    ScrollTrigger.create({
      trigger: sectionRefs.current[section.id],
      start: "top top",
      end: "bottom top",
      // pin: true,
      pinSpacing: false,
    });
  });
}, []);

  return (
    <div className="whatwedo product section--land">

      {/* HERO */}
      <section className="section section--subkv section--main">
        <div className="section--main-wrapper">
          <div className="main-cont">
            <div className="container">
              <div className="row">
                <div className="title col-10 col-offset-2">
                  <h1 className="headline-6">
                    Industry We Serve
                  </h1>
                  <p className="desc body1 trn" data-trn-key="index-09">Cross-Domain Intelligence. Single-Source Precision. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="section-product-wrap section--vision">

        {/* TAB MENU */}
        <div className="product-tab-action">
          <ul>
            {sections.map((tab) => (
              <li key={tab.id}>
                <button
                  ref={(el) =>
                    (tabRefs.current[tab.id] = el)
                  }
                  className={
                    activeTab === tab.id
                      ? "is-active"
                      : ""
                  }
                  onClick={() =>
                    handleTabClick(tab.id)
                  }
                >
                  {tab.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* SECTIONS */}
        {sections.map((section) => (
         <section
          key={section.id}
          id={section.id}
          ref={(el) =>
            (sectionRefs.current[section.id] = el)
          }
          className={`product-section ${
            activeTab === section.id ? "is-active" : ""
          }`}>
            <div className="section-product-contents">

              <div className="section-product-title">
                <div className="container">
                  <div className="row">
                    <div className="col-10">
                      <p className="headline-2-en">
                        {section.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="section-product-list">
                <div className="container">
                  <div className="row">
                    <div className="col-14 product-list">

                      {section.products.map(
                        (prods, index) => (
                          <div
                            key={index}
                            className="product-item three"
                          >
                            <a href="/">
                              <div className="inner">
                                <img
                                  src={prods.img}
                                  alt={prods.title}
                                />
                              </div>

                              <div className="product-title">
                                <p className="title1-kr">
                                  {prods.name}
                                </p>

                                <p>
                                  {prods.description}
                                </p>
                              </div>
                            </a>
                          </div>
                        )
                      )}

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>
        ))}
      </section>
    </div>
  );
};

export default WhatWeDo;